import React from "react";
import { MessageSquareText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEnquiry } from "@/context/EnquiryContext";

export function EnquireButton({ course = "", className = "", size = "default", variant = "outline", testId = "enquire-btn", label = "Enquire Now" }) {
  const { openEnquiry } = useEnquiry();
  return (
    <Button type="button" size={size} variant={variant} className={className} onClick={() => openEnquiry(course)} data-testid={testId}>
      <MessageSquareText className="mr-2 h-4 w-4" /> {label}
    </Button>
  );
}

export function FloatingEnquire() {
  const { openEnquiry } = useEnquiry();
  return (
    <button
      type="button"
      onClick={() => openEnquiry()}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[hsl(var(--brand-orange))] px-5 py-3 text-sm font-semibold text-white shadow-xl transition-transform hover:-translate-y-0.5 print:hidden"
      data-testid="floating-enquire-btn"
    >
      <MessageSquareText className="h-4 w-4" /> Enquire Now
    </button>
  );
}
